// extracted by mini-css-extract-plugin
export default {"boxWrapper":"pV1Dn","boxContent":"pUTpF"};